import { render, staticRenderFns } from "./storyBoxOpener.vue?vue&type=template&id=2b252825&scoped=true&"
import script from "./storyBoxOpener.vue?vue&type=script&lang=js&"
export * from "./storyBoxOpener.vue?vue&type=script&lang=js&"
import style0 from "./storyBoxOpener.vue?vue&type=style&index=0&id=2b252825&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b252825",
  null
  
)

export default component.exports